import { axiosInstance } from "./axiosInstance";

const getCredentials = () => {
    return axiosInstance.get('credential-types');
}

const createCredential = (data) => {
    return axiosInstance.post('credential-types', data);
}

const createMembership = (data) => {
    return axiosInstance.post('credential-types/membership', data);
}

const updateCredential = (data) => {
    return axiosInstance.put('credential-types', data);
}
const updateMembership = (data) => {
    return axiosInstance.put('credential-types/membership', data);
}

const deleteCredential = (data) => {
    return axiosInstance.delete('credential-types', {params: data});
}

const getPsypact = () => {
    return axiosInstance.get('degrees/display-psypact-provider');
}

const updatePsypact = (data) => {
    return axiosInstance.put('degrees/psypact-provider', data);
}

export {
    getCredentials,
    createCredential,
    createMembership,
    updateCredential,
    updateMembership,
    deleteCredential,
    getPsypact,
    updatePsypact,
}